import { useAppSelector } from '@/hooks';
import { DeepPartialExcept } from '../types/lib/DeepPartial';

export const getIsGewerblicherAntragsprozess = (
  state: DeepPartialExcept<RootState, { userData: { deviceModeOverride: true }; devicemode: { devkey: true } }>
) => {
  const devicemode = state.userData.deviceModeOverride || state.devicemode.devkey;
  return devicemode === 'gewerblich';
};

export const useIsGewerblicherAntragsprozess = () => {
  const state = useAppSelector((state) => state);
  return getIsGewerblicherAntragsprozess(state);
};
